"use client";
import { IBlocks } from "@/types";
import React from "react";
import { IconBadgeVrFilled } from "@tabler/icons-react";
import { Label } from "@/components/ui/label";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import LoadingSkeleton from "@/components/admin/profile/blocks/LoadingSkeleton";
import AdminPopover from "./utils/AdminPopover";
interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
}
export default function BlockVrcdnLive({ edit, block, update }: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);

    const [vrcdn, setVRCDN] = React.useState<any>(true);
    const [loading, setLoading] = React.useState(false);
    const [hide, setHide] = React.useState(false);

    // Video JS
    const videoRef = React.useRef<HTMLVideoElement>(null);
    const playerRef = React.useRef<any>(null);

    React.useEffect(() => {
        // Wait for next tick to ensure DOM is ready
        const timer = setTimeout(() => {
            const videoElement = videoRef.current;
            if (!videoElement || !blockUpdate.url) return;

            const player = videojs(videoElement, {
                controls: true,
                fluid: true,
                preload: "none",
                liveui: true,
                liveTracker: false,
                controlBar: {
                    progressControl: false,
                },
                html5: {
                    nativeVideoTracks: true,
                    nativeAudioTracks: true,
                    nativeTextTracks: true,
                    vhs: {
                        overrideNative: true,
                        bufferSize: 1, // Minimal buffer size
                        maxBufferLength: 1, // Only buffer 1 second
                        // Add periodic buffer cleanup
                        cleanupBuffer: true,
                        cleanupBufferInterval: 30, // seconds
                    },
                },
            });

            playerRef.current = player;
        }, 0);

        return () => {
            clearTimeout(timer);
            if (playerRef.current) {
                playerRef.current.reset();
                playerRef.current.dispose();
                playerRef.current = null;
            }
        };
    }, [blockUpdate.url]);

    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={`VRCDN - ${blockUpdate.url}`}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            {!hide ? (
                <div
                    className={`relative aspect-video w-full min-w-full overflow-hidden rounded-lg`}
                >
                    <div
                        className={`absolute flex w-full min-w-full place-content-center items-center justify-center transition-opacity duration-300 ${loading ? "opacity-100" : "pointer-events-none opacity-0"}`}
                    >
                        <LoadingSkeleton />
                        <IconBadgeVrFilled
                            className="absolute z-50 animate-bounce rounded-md bg-[#3be2e2] p-1 text-background shadow-xl"
                            size={40}
                        />
                    </div>
                    <div
                        className={`w-full min-w-full transition-opacity duration-300 ${loading ? "opacity-0" : "opacity-100"}`}
                    >
                        {vrcdn ? (
                            <div data-vjs-player className="h-full w-full ">
                                <video
                                    ref={videoRef}
                                    className="video-js vjs-live vjs-live-display h-full w-full"
                                    playsInline
                                >
                                    <source
                                        src={`https://stream.vrcdn.live/live/${blockUpdate.url}.live.mp4`}
                                        type="video/mp4"
                                    />
                                </video>
                            </div>
                        ) : (
                            // <VrcdnLiveVideo username={blockUpdate.url} />
                            <div
                                className={`absolute flex w-full min-w-full place-content-center items-center justify-center opacity-100 transition-opacity duration-300`}
                            >
                                <LoadingSkeleton nopulse />
                                <div className="absolute flex flex-col items-center">
                                    <IconBadgeVrFilled
                                        className="z-50 rounded-md bg-[#3be2e2] p-1 text-background shadow-xl"
                                        size={40}
                                    />
                                    <Label className="" variant="headingtoggle">
                                        (Preview)
                                    </Label>
                                    <Label className="" variant="headingtoggle">
                                        Stream will appear here when it's live.
                                    </Label>
                                </div>
                            </div>
                        )}
                        {}
                    </div>
                </div>
            ) : edit ? (
                <div
                    className={`absolute flex w-full min-w-full place-content-center items-center justify-center opacity-100 transition-opacity duration-300`}
                >
                    <LoadingSkeleton nopulse />
                    <div className="absolute flex flex-col items-center">
                        <IconBadgeVrFilled
                            className="z-50 rounded-md bg-[#3be2e2] p-1 text-background shadow-xl"
                            size={40}
                        />
                        <Label className="" variant="headingtoggle">
                            (Preview)
                        </Label>
                        <Label className="" variant="headingtoggle">
                            Stream will appear here when it's live.
                        </Label>
                    </div>
                </div>
            ) : (
                HideElementsByClass(block.id)
            )}
        </AdminPopover>
    );
}
function HideElementsByClass(block_id: string) {
    if (
        window.document &&
        window.document.getElementsByClassName("block-" + block_id)[0]
    ) {
        // Get all elements with the class name 'block-' + block_id
        const elements = document.getElementsByClassName("block-" + block_id);
        // Loop through each element and add the 'hidden' attribute
        for (var i = 0; i < elements.length; i++) {
            elements[i].classList.add("hidden");
        }
        return null;
    }
    return null;
}
